export const getRankingItems = (question) => {
  const options = [
    question?.options,
    question?.options?.options,
    question?.options?.choices,
    question?.choices,
    question?.rows,
  ].find((candidate) => Array.isArray(candidate) && candidate.length > 0) || [];

  return options.map((option, index) => ({
    id: index,
    text: typeof option === 'string'
      ? option
      : option?.text ?? option?.label ?? String(option),
  }));
};

export const reorderRankingItems = (items, draggedId, targetId) => {
  if (!Array.isArray(items) || draggedId == null || targetId == null) {
    return items;
  }

  const draggedIndex = items.findIndex((item) => item.id === draggedId);
  const targetIndex = items.findIndex((item) => item.id === targetId);

  if (draggedIndex < 0 || targetIndex < 0 || draggedIndex === targetIndex) {
    return items;
  }

  const reorderedItems = [...items];
  const [draggedItem] = reorderedItems.splice(draggedIndex, 1);
  reorderedItems.splice(targetIndex, 0, draggedItem);
  return reorderedItems;
};
